(() => {
  const init = (root) => {

    if (!root || root.dataset.erInitialized === 'true') return;
    root.dataset.erInitialized = 'true';
    if(!matchMedia('(prefers-reduced-motion:reduce)').matches){const items=[...root.querySelectorAll('.ermusic__section')];if(items.length){root.classList.add('ermusic--reveal');if('IntersectionObserver'in window){const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');io.unobserve(e.target)}}),{threshold:.12,rootMargin:'0px 0px -8% 0px'});items.forEach(i=>io.observe(i))}else items.forEach(i=>i.classList.add('is-visible'))}}
    const artwork = root.querySelector('.ermusic__cover-image:not(.ermusic__placeholder)');
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const mixColor = (from, to, amount) => [
    Math.round(from[0] + ((to[0] - from[0]) * amount)),
    Math.round(from[1] + ((to[1] - from[1]) * amount)),
    Math.round(from[2] + ((to[2] - from[2]) * amount))
    ];
    const luminance = ([r, g, b]) => (0.2126 * r) + (0.7152 * g) + (0.0722 * b);
    const colorDistance = (a, b) => {
    const dr = a[0] - b[0];
    const dg = a[1] - b[1];
    const db = a[2] - b[2];
    return Math.sqrt((dr * dr) + (dg * dg) + (db * db));
    };
    const softenColor = ([r, g, b]) => {
    const luminance = (0.2126 * r) + (0.7152 * g) + (0.0722 * b);
    let target = 128;
    let mix = 0.08;
    if (luminance < 48) {
    target = 150;
    mix = 0.28;
    } else if (luminance > 218) {
    target = 150;
    mix = 0.24;
    }
    return [
    Math.round(clamp((r * (1 - mix)) + (target * mix), 24, 232)),
    Math.round(clamp((g * (1 - mix)) + (target * mix), 24, 232)),
    Math.round(clamp((b * (1 - mix)) + (target * mix), 24, 232))
    ];
    };
    const extractPalette = (image) => {
    const canvas = document.createElement('canvas');
    const size = 48;
    canvas.width = size;
    canvas.height = size;
    const context = canvas.getContext('2d', { willReadFrequently: true });
    if (!context) return null;
    context.drawImage(image, 0, 0, size, size);
    const pixels = context.getImageData(0, 0, size, size).data;
    const buckets = new Map();
    for (let i = 0; i < pixels.length; i += 4) {
    const alpha = pixels[i + 3];
    if (alpha < 180) continue;
    const r = pixels[i];
    const g = pixels[i + 1];
    const b = pixels[i + 2];
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const saturation = max === 0 ? 0 : (max - min) / max;
    const luminance = (0.2126 * r) + (0.7152 * g) + (0.0722 * b);
    if (luminance < 16 || luminance > 242) continue;
    const qr = Math.round(r / 32) * 32;
    const qg = Math.round(g / 32) * 32;
    const qb = Math.round(b / 32) * 32;
    const key = `${qr},${qg},${qb}`;
    const weight = 0.45 + (saturation * 1.55);
    const existing = buckets.get(key) || { score: 0, count: 0, r: 0, g: 0, b: 0 };
    existing.score += weight;
    existing.count += 1;
    existing.r += r;
    existing.g += g;
    existing.b += b;
    buckets.set(key, existing);
    }
    const ranked = [...buckets.values()]
    .filter(bucket => bucket.count >= 2)
    .map(bucket => ({
    score: bucket.score,
    color: [
    Math.round(bucket.r / bucket.count),
    Math.round(bucket.g / bucket.count),
    Math.round(bucket.b / bucket.count)
    ]
    }))
    .sort((a, b) => b.score - a.score);
    if (!ranked.length) return null;
    const primary = softenColor(ranked[0].color);
    let secondary = primary;
    for (const candidate of ranked.slice(1)) {
    const softened = softenColor(candidate.color);
    if (colorDistance(primary, softened) >= 72) {
    secondary = softened;
    break;
    }
    }
    return { primary, secondary };
    };
    const applyPaletteToUI = (palette) => {
    if (!palette) return;
    const primary = palette.primary;
    const secondary = palette.secondary;
    const textPrimary = mixColor([250, 250, 250], primary, 0.36);
    const textSecondary = mixColor([215, 215, 215], primary, 0.30);
    let buttonBg = primary;
    const buttonLum = luminance(buttonBg);
    if (buttonLum < 86) buttonBg = mixColor(buttonBg, [255, 255, 255], 0.34);
    if (buttonLum > 220) buttonBg = mixColor(buttonBg, [0, 0, 0], 0.16);
    const buttonText = luminance(buttonBg) > 148 ? [15, 15, 15] : [250, 250, 250];
    root.style.setProperty('--er-art-primary', primary.join(', '));
    root.style.setProperty('--er-art-secondary', secondary.join(', '));
    root.style.setProperty('--er-text-primary', textPrimary.join(', '));
    root.style.setProperty('--er-text-secondary', textSecondary.join(', '));
    root.style.setProperty('--er-button-bg', buttonBg.join(', '));
    root.style.setProperty('--er-button-text', buttonText.join(', '));
    root.dataset.erPalette = `${primary.join('-')}|${secondary.join('-')}`;
    root.classList.add('ermusic--artwork-ready');
    };
    const applyArtworkPalette = () => {
    if (!artwork) return;
    try {
    const directPalette = extractPalette(artwork);
    if (directPalette) {
    applyPaletteToUI(directPalette);
    return;
    }
    } catch (error) {
    }
    const source = artwork.currentSrc || artwork.src;
    if (!source) return;
    const sampler = new Image();
    sampler.crossOrigin = 'anonymous';
    sampler.decoding = 'async';
    sampler.onload = () => {
    try {
    applyPaletteToUI(extractPalette(sampler));
    } catch (error) {
    }
    };
    sampler.src = source;
    };
    if (artwork) {
    if (artwork.complete && artwork.naturalWidth > 0) {
    applyArtworkPalette();
    } else {
    artwork.addEventListener('load', applyArtworkPalette, { once: true });
    }
    }
    const previewPlayer = root.querySelector('[data-er-preview-player]');
    const previewAudio = root.querySelector('[data-er-audio]');
    const previewToggle = root.querySelector('[data-er-preview-toggle]');
    const previewSeek = root.querySelector('[data-er-preview-seek]');
    const previewTime = root.querySelector('[data-er-preview-time]');
    if (previewPlayer && previewAudio && previewToggle && previewSeek && previewTime) {
    const PREVIEW_LIMIT_SECONDS = 60;
    const formatTime = (seconds) => {
    if (!Number.isFinite(seconds) || seconds < 0) return '--:--';
    const wholeSeconds = Math.floor(seconds);
    const minutes = Math.floor(wholeSeconds / 60);
    const remainingSeconds = wholeSeconds % 60;
    return `${minutes}:${String(remainingSeconds).padStart(2, '0')}`;
    };
    const getPreviewDuration = () => {
    const sourceDuration = Number.isFinite(previewAudio.duration) ? previewAudio.duration : 0;
    return sourceDuration > 0 ? Math.min(sourceDuration, PREVIEW_LIMIT_SECONDS) : PREVIEW_LIMIT_SECONDS;
    };
    const updatePreviewUI = () => {
    const duration = getPreviewDuration();
    const currentTime = Math.min(
    Number.isFinite(previewAudio.currentTime) ? previewAudio.currentTime : 0,
    duration
    );
    const progress = duration > 0 ? clamp((currentTime / duration) * 100, 0, 100) : 0;
    previewSeek.value = progress.toFixed(2);
    previewPlayer.style.setProperty('--er-preview-progress', `${progress}%`);
    previewTime.textContent = `${formatTime(currentTime)} / ${formatTime(duration)}`;
    };
    const setPreviewPlayingState = (playing) => {
    previewPlayer.classList.toggle('ermusic__preview--playing', playing);
    previewToggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
    previewToggle.setAttribute('aria-label', playing ? 'Pause audio preview' : 'Play audio preview');
    };
    const finishPreview = () => {
    previewAudio.pause();
    previewAudio.currentTime = 0;
    setPreviewPlayingState(false);
    updatePreviewUI();
    };
    previewToggle.addEventListener('click', async () => {
    if (previewAudio.paused) {
    const duration = getPreviewDuration();
    if (previewAudio.currentTime >= duration - 0.05) {
    previewAudio.currentTime = 0;
    }
    document.querySelectorAll('audio[data-er-audio]').forEach((audio) => {
    if (audio !== previewAudio && !audio.paused) audio.pause();
    });
    try {
    await previewAudio.play();
    } catch (error) {
    setPreviewPlayingState(false);
    }
    } else {
    previewAudio.pause();
    }
    });
    previewSeek.addEventListener('input', () => {
    const duration = getPreviewDuration();
    if (duration <= 0) return;
    const progress = clamp(Number(previewSeek.value) || 0, 0, 100);
    previewAudio.currentTime = (progress / 100) * duration;
    updatePreviewUI();
    });
    previewAudio.addEventListener('loadedmetadata', updatePreviewUI);
    previewAudio.addEventListener('durationchange', updatePreviewUI);
    previewAudio.addEventListener('timeupdate', () => {
    const duration = getPreviewDuration();
    if (previewAudio.currentTime >= duration - 0.05) {
    finishPreview();
    return;
    }
    updatePreviewUI();
    });
    previewAudio.addEventListener('play', () => setPreviewPlayingState(true));
    previewAudio.addEventListener('pause', () => setPreviewPlayingState(false));
    previewAudio.addEventListener('ended', finishPreview);
    previewAudio.addEventListener('error', () => {
    setPreviewPlayingState(false);
    previewToggle.disabled = true;
    previewToggle.setAttribute('aria-label', 'Audio preview unavailable');
    previewTime.textContent = 'Preview unavailable';
    });
    updatePreviewUI();
    }
    const select = root.querySelector('[data-er-variant-select]');
    const price = root.querySelector('[data-er-price]');
    const compare = root.querySelector('[data-er-compare]');
    const button = root.querySelector('[data-er-add-button]');
    const buttonText = root.querySelector('[data-er-add-text]');
    if (select && price && button && buttonText) {
    const updateVariant = () => {
    const option = select.options[select.selectedIndex];
    if (!option) return;
    price.textContent = option.dataset.price || '';
    if (compare) {
    const comparePrice = option.dataset.compare || '';
    compare.textContent = comparePrice;
    compare.hidden = !comparePrice;
    }
    const available = option.dataset.available === 'true';
    button.disabled = !available;
    buttonText.textContent = available ? 'Add to cart' : 'Unavailable';
    };
    select.addEventListener('change', updateVariant);
    updateVariant();
    }
  };

  const initAll = (scope = document) => {
    if (scope.matches && scope.matches('[data-er-music-single]')) init(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-er-music-single]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
